import { Stack } from '@mui/system';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../../hooks';
import { getGenerationId } from '../../../../store/GenerationSlice';
import { deleteConversation, sendConversationMessage } from '../../../../store/ConversationSlice';
import { AppDispatch, RootState } from '../../../../store/store';
import { Mode } from '../../../../types/common';
import { BaseForm, FormInput } from '../../../UI';

const INIT_INPUT = {
  message: '',
};

const VALIDATE_FIELDS = ['message'];

const AIChatForm: React.FC = () => {
  const { input, error, handleChange, submit, resetForm, tags, handleAddTag, handleDeleteTag, handlePressKey } =
    useForm(INIT_INPUT, handleSubmit, VALIDATE_FIELDS);
  const { isGenerationLoading, isHistoryLoading } = useSelector((state: RootState) => state.generation);
  const dispatch = useDispatch<AppDispatch>();

  function handleSubmit() {
    dispatch(sendConversationMessage(input));
  }

  function clearConversation() {
    dispatch(deleteConversation());
  }

  return (
    <BaseForm onSubmit={submit} onReset={clearConversation}>
      <Stack gap={'20px'} pb={'20px'}>
        <FormInput
          onChange={handleChange}
          error={error?.message || ''}
          name={'message'}
          value={input.message || ''}
          placeholder={'Напиши статью на тему «Как начать жить экологично». \n\nТон статьи: дружеский, экспертный.\n\nРаскрой в статье следующие темы:\n\
  - Какой вред мы наносим планете и что с этим делать;\n\
  - Что такое разумное потребление;\n\
  - Как легко начать сортировать мусор;\n\
  - Как развивать полезные экопривычки.'}
          label={'Ваше сообщение'}
          maxLength={2000}
          required
          multiline={true}
          minRows={12}
          maxRows={12}
        />
      </Stack>
    </BaseForm>
  );
};

export default AIChatForm;
